import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询队伍最大金额限制详情
export const getTeamPayoutList = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamPayoutList", params);
};




// WEBPACK FOOTER //
// ./src/api/manage/teamPayout.js